import React from 'react';
import CrudTable from '../table/crudtable'
import { predefinedConfigurationService } from '../../_services'
import PredefinedConfigurationForm from './predefinedconfigurationform.component'
import { useTranslation } from "react-i18next";
import moment from 'moment'
import { SERVER_URL } from '../../config';

function PredefinedConfiguration() {

	const {t} = useTranslation('common');

	const initialState = {
		customerId: -1,
		name: '',
		type: 'NEXT',
		params: { token: '' }
	}

	const formatParams = function(cell) {
		return <>
			{ Object.keys(cell).map((key, index) => {
				return <div key={key}>{key}: {cell[key]}</div>
			})}
		</>
	}

	const paramsFilterValues = function(cell) {
		return Object.keys(cell).map((key, index) => {
			return key + ": " + cell[key]
		}).join(" ")
	}

	const formatTest = function(cell, row) {
		return <a href={SERVER_URL + '/exportConfiguration/test/' + row.id} target="_blank">Test</a>
	}

	const columns = [
		{
			dataField: 'name',
			text: t('predefinedconfiguration.columns.name'),
			sort: true
		},
		{
			dataField: 'customerName',
			text: t('predefinedconfiguration.columns.customer'),
			sort: true
		},
		{
			dataField: 'type',
			text: t('predefinedconfiguration.columns.type'),
			sort: true
		},
		{
			dataField: 'params',
			text: t('predefinedconfiguration.columns.params'),
			formatter: formatParams,
			filterValue: paramsFilterValues
		}
	]

	return (
		<div>
			<h2>
				{t('predefinedconfiguration.label')}
			</h2>
			<CrudTable
				service={predefinedConfigurationService}
				columns={columns}
				initialState={initialState}
				form={<PredefinedConfigurationForm />}
				sort={{dataField: 'customerName', order: 'asc'}}
				modalSize="md"
				urlParams={true}
			/>
		</div>
	)
}

export default PredefinedConfiguration;